import React, { Component } from 'react';

class SaveSurgeonBackModal extends Component {
  render() {
    const { onSave, onCancel } = this.props;
    return (
      <div
        className="modal fade theme-modal" id="saveSurgeonBackModal"
        tabIndex="-1" aria-labelledby="saveSurgeonBackModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body">
              <p className="mb-0">Do you want to save changes first?</p>
            </div>
            <div className="modal-footer">
              <div className="row gx-2">
                <div className="col-6">
                  <button
                    type="button"
                    className="btn btn-gray w-100"
                    data-bs-dismiss="modal"
                    onClick={() => onCancel()}
                  >
                    No
                  </button>
                </div>
                <div className="col-6">
                  <button
                    type="button"
                    className="btn btn-gray w-100"
                    data-bs-dismiss="modal"
                    onClick={() => onSave()}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SaveSurgeonBackModal;
